import axios from "axios";

export const datetimeSettingService = {
  datetimeSetting
};

function datetimeSetting() {
  //debugger;
  return axios.get(`${process.env.VUE_APP_API_URL}/datetime-setting/one`);
}
